<template>
  <div class="template-354">
    <div class="chunk-warp line-one">
      <div class="img-box count-down">
        <img src="@assets/images/354/13.png" alt="" />
        <!-- <span class="day">{{ countdown.days }}</span>
        <span class="hours">{{ countdown.hours }}</span> -->
      </div>
      <div class="img-box">
        <img
          src="@assets/images/354/2.jpg"
          @click="handleClick(data[0])"
          alt=""
        />
      </div>
      <div class="img-box">
        <img
          src="@assets/images/354/3.jpg"
          @click="handleClick(data[1])"
          alt=""
        />
      </div>
    </div>
    <div class="chunk-warp line-two">
      <div class="img-box">
        <img
          src="@assets/images/354/4.jpg"
          @click="handleClick(data[2])"
          alt=""
        />
      </div>
      <div class="img-box">
        <img
          src="@assets/images/354/6.jpg"
          @click="handleClick(data[3], true)"
          alt=""
        />
        <img
          src="@assets/images/354/7.jpg"
          @click="handleClick(data[4])"
          alt=""
        />
      </div>
    </div>
    <div class="chunk-warp line-three">
      <div class="img-box">
        <img
          src="@assets/images/354/8.jpg"
          @click="handleClick(data[5])"
          alt=""
        />
      </div>
      <div class="img-box">
        <img
          src="@assets/images/354/9.jpg"
          @click="handleClick(data[6])"
          alt=""
        />
      </div>
      <div class="img-box">
        <img
          src="@assets/images/354/12.jpg"
          @click="handleClick(data[8])"
          alt=""
        />
      </div>
    </div>
    <div class="chunk-warp line-four">
      <div class="img-box">
        <img
          src="@assets/images/354/10.png"
          @click="handleClick(data[7])"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
import os from '@utils/os'
export default {
  props: {
    data: {
      type: Array
    },
    serveTime: {},
    subjectTime: {}
  },
  data () {
    return {
      countdown: {
        days: 0,
        hours: 0
      },
      interval: null
    }
  },
  mounted () {
    // this.initCountdown();
    // this.interval = setInterval(this.updateCountdown, 1000 * 60); // 每分钟更新一次
  },
  computed: {
    isUid () {
      return this.$route.query.meetingId && this.$route.query.uid
    }
  },
  beforeDestroy () {
    clearInterval(this.interval);
  },
  methods: {
    handleClick (item, flag = false) {
      if (item.jump_type == 1) {
        if (item.is_home == 1) {
          this.$router.push({
            path: '/detailIframe',
            query: {
              url: item.content_url,
              isHome: item.is_home,
              id: this.$route.query.id
            }
          })
        } else {
          // 参会链接标识
          if (flag) {
            // 构造参会链接
            const baseUrl = this.isUid
              ? `${item.content_url}&meetingId=${this.$route.query.meetingId}&uid=${this.$route.query.uid}`
              : 'https://s.hoohui.cn/xNdoQ10'
            if (os.isPC()) {
              // PC 端：小程序内用跳转，其他用新窗口打开
              os.isInWechatMiniProgram()
                ? window.location.href = baseUrl
                : window.open(baseUrl)
            } else {
              // 移动端直接跳转
              window.location.href = baseUrl
            }
          } else {
            let targetUrl = item.content_url
            // 判断是否需要追加 pf 和 uid 参数（CCAapp 跳转场景）
            const isDocbookUrl = /m\.docbook\.com\.cn|docbook\.com\.cn/.test(targetUrl)
            if (isDocbookUrl && this.isUid) {
              targetUrl = os.appendQuery(targetUrl, {
                platform: this.$route.query.platform,
                uid: this.$route.query.uid
              })
            }

            // 根据环境决定打开方式
            if (os.isPC()) {

              if (os.isInWechatMiniProgram()) {
                // 如果是 schedule.docbook.com.cn 域名添加 iframe=true
                if (/schedule\.docbook\.com\.cn/.test(targetUrl)) {
                  targetUrl = os.appendQuery(targetUrl, { iframe: 'true' })
                }
                window.location.href = targetUrl
              } else {
                window.open(targetUrl)
              }
            } else {
              window.location.href = targetUrl
            }
          }
        }
      } else {
        this.$router.push({
          path: '/detail',
          query: {
            id: item.id,
            isHome: item.is_home
          }
        })
      }
    },
    // 354 倒计时
    initCountdown () {
      console.log(this.subjectTime, this.serveTime)
      const serverTimeMs = Number(this.serveTime) * 1000;
      const targetTime = new Date(this.subjectTime).getTime();

      if (isNaN(serverTimeMs) || isNaN(targetTime)) {
        this.invalidTime = true;
        this.loading = false;
        return;
      }

      this.baseTime = serverTimeMs;
      this.targetTime = targetTime;

      this.updateCountdown();
      this.loading = false;
    },
    updateCountdown () {
      const now = Date.now();
      const diff = this.targetTime - now;

      if (diff <= 0) {
        this.countdown.days = 0;
        this.countdown.hours = 0;
        clearInterval(this.interval);
        return;
      }

      const totalHours = Math.floor(diff / (1000 * 60 * 60));
      this.countdown.days = Math.floor(totalHours / 24);
      this.countdown.hours = totalHours % 24;
    }
  },
}
</script>

<style lang="scss" scoped>
@font-face {
  font-family: "AlibabaPuHuiTi-3-85-Bold";
  src: url("../../../../assets/font/AlibabaPuHuiTi-3-85-Bold.ttf")
    format("opentype");
  opacity: 1;
}
.template-354 {
  margin-top: -0.2rem;
  .chunk-warp {
    display: flex;
    align-items: center;
  }
  .count-down {
    position: relative;
    .day {
      position: absolute;
      left: 1rem;
      top: 2.5rem;
      width: 1.5rem;
      font-size: 1.3rem;
      text-align: center;
      color: #163d96;
      font-family: "AlibabaPuHuiTi-3-85-Bold";
    }
    .hours {
      position: absolute;
      left: 3.1rem;
      top: 2.5rem;
      width: 1.5rem;
      color: #163d96;
      text-align: center;
      font-size: 1.3rem;
      font-family: "AlibabaPuHuiTi-3-85-Bold";
    }
  }
  .line-one .img-box {
    width: 33.33%;
    // height: 4rem;
    img {
      width: 100%;
      cursor: pointer;
    }
  }
  .line-two .img-box {
    width: 50%;
    // height: 4rem;
    img {
      width: 100%;
      cursor: pointer;
    }
  }
  .line-three .img-box {
    width: 50%;
    // height: 4rem;
    img {
      width: 100%;
      cursor: pointer;
    }
  }
  .line-four .img-box {
    width: 100%;
    // height: 4rem;
    img {
      width: 100%;
      cursor: pointer;
    }
  }
}
</style>